import React from "react";
import { useTranslation } from "react-i18next";
import SharedButton from "../Shared/SharedButton";
import { FaF, FaFilter } from "react-icons/fa6";
import DatePicker from "../Shared/DatePicker";
import moment from "moment";

function FilterComponent({
  filterDate,
  setFilterDate,
  handleUpdateFilters,
  loading,
}) {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <div className="flex gap-2">
        <div className="flex gap-2">
          <DatePicker
            name="start_date"
            useFormik={false}
            placeholder={t("StartDate")}
            className="w-full sm:w-[250px]"
            value={moment(filterDate?.start_date).toDate()}
            onChange={(e) => {
              setFilterDate((prevDates) => ({
                ...prevDates,
                start_date: moment(e.value).format("YYYY-MM-DD"),
              }));
            }}
          />
          <DatePicker
            name="end_date"
            useFormik={false}
            placeholder={t("EndDate")}
            className="w-full sm:w-[250px]"
            value={moment(filterDate?.end_date).toDate()}
            onChange={(e) => {
              setFilterDate((prevDates) => ({
                ...prevDates,
                end_date: moment(e.value).format("YYYY-MM-DD"),
              }));
            }}
          />
        </div>
        <div className="">
          <SharedButton
            loading={loading}
            onClick={handleUpdateFilters}
            icon='pi pi-filter'
            title={t("Filter")}
          />
        </div>
      </div>
    </React.Fragment>
  );
}

export default FilterComponent;
